import * as getters from "../../baseQuestion/searchableDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableDDL/store/state";

function state() {
	return Object.assign(
		{
			option_source: {
				type: "minor",
				filter: [
					{
						operand: "institution",
						operator: "=",
						argument: "UMS03"
					}
				]
			}
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
